module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/journal/airstrike-elite.99d1862a.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/journal/airstrike-elite.png
// module id = 3729
// module chunks = 11